import { render, staticRenderFns } from "./ShowSetPage.vue?vue&type=template&id=89de1d2a&scoped=true&"
import script from "./ShowSetPage.vue?vue&type=script&lang=js&"
export * from "./ShowSetPage.vue?vue&type=script&lang=js&"
import style0 from "./ShowSetPage.vue?vue&type=style&index=0&id=89de1d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89de1d2a",
  null
  
)

export default component.exports